import React from 'react';
import style from './RoundedButton.module.css';

function RoundedButton ({ 
  backgroundColor = 'white',
  text = '텍스트를 입력하세요',
  textColor = '#FF6A5D',
  width = 201,
  height = 52
}) {
  return (
    <div 
      className={style.container}
      style={{
        width: `${width}px`,
        height: `${height}px`
      }}
    >
      <div 
        className={style.button}
        style={{
          backgroundColor,
          borderRadius: `${height/2}px`,
        }}
      >
        <div 
          className={style.textArea}
          style={{ color: textColor }}
        >
          {text}
        </div>
        
        <div className={style.iconArea}>
          <svg 
            width="36" 
            height="36" 
            viewBox="0 0 82 82" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              fillRule="evenodd" 
              clipRule="evenodd" 
              d="M23.0238 43.4266H50.1661L39.6286 53.9641C38.6707 54.922 38.6707 56.5186 39.6286 57.4765C40.5866 58.4345 42.1831 58.4345 43.1411 57.4765L57.5102 43.1074C58.1488 42.4687 58.1488 41.5108 58.1488 40.8721C58.1488 40.2335 58.1488 39.2756 57.5102 38.637L43.1411 24.2679C42.1831 23.3099 40.5866 23.3099 39.6286 24.2679C38.6707 25.2258 38.6707 26.8224 39.6286 27.7803L50.1661 38.3177H23.0238C21.7466 38.3177 20.4694 39.5949 20.4694 40.8721C20.4694 42.1494 21.7466 43.4266 23.0238 43.4266ZM40.9058 81.7442C63.577 81.7442 81.7779 63.5433 81.7779 40.8721C81.7779 18.2009 63.577 0 40.9058 0C18.2346 0 0.0337524 18.2009 0.0337524 40.8721C0.0337524 63.5433 18.2346 81.7442 40.9058 81.7442ZM40.9058 5.10902C60.703 5.10902 76.6689 21.0747 76.6689 40.8721C76.6689 60.6695 60.703 76.6352 40.9058 76.6352C21.1084 76.6352 5.14276 60.6695 5.14276 40.8721C5.14276 21.0747 21.1084 5.10902 40.9058 5.10902Z" 
              fill={textColor}
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default RoundedButton;